import React, { useEffect, useState } from 'react';

import '../styles/components/BgSprinkles.scss';

import cross from '../assets/background_cross.svg';
import line from '../assets/background_line.svg';

export default function BgSprinkles({ amount }) {
	const width = window.innerWidth;
	const [height, setHeight] = useState(window.innerHeight);
	const arr: Record<string, unknown>[] = [];

	for (let i = 0; i < amount; i++) {
		const x = Math.floor(Math.random() * (width - 1) + 1);
		const y = Math.floor(Math.random() * (height - 1) + 1);
		const img = x % 2 === 0 ? line : cross;
		const obj = { key: i, img: img, xPos: x, yPos: y };
		arr.push(obj);
	}
	useEffect(() => {
		setHeight(document.body.offsetHeight);
	}, []);
	return (
		<div className='sprinkles-wrapper'>
			{arr.map(item => {
				return (
					<div
						className='sprinkle-container'
						style={{
							background: `url(${item.img})`,
							left: `${item.xPos}px`,
							top: `${item.yPos}px`,
							transform: `rotate(${item.xPos}deg)`,
						}}
					></div>
				);
			})}
		</div>
	);
}
